import React, { type ComponentProps } from 'react';
import { Platform } from 'react-native';

import { OrganizationLinksFooter } from '../OrganizationLinksFooter';

// This footer component is only present on web, not on native.
export const AppFooter = (props: Props) => {
  const { style } = props;

  if (Platform.OS !== 'web') return null;

  return <OrganizationLinksFooter style={style} />;
};

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = ComponentProps<typeof OrganizationLinksFooter>;
